import { render, staticRenderFns } from "./Comment.vue?vue&type=template&id=4c83afbf&scoped=true&"
import script from "./Comment.vue?vue&type=script&lang=js&"
export * from "./Comment.vue?vue&type=script&lang=js&"
import style0 from "../Style/comment.scss?vue&type=style&index=0&id=4c83afbf&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c83afbf",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("n:\\Data\\Projects\\Werk\\DPG\\DNX2-DPG\\MarketingDb.Web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4c83afbf')) {
      api.createRecord('4c83afbf', component.options)
    } else {
      api.reload('4c83afbf', component.options)
    }
    module.hot.accept("./Comment.vue?vue&type=template&id=4c83afbf&scoped=true&", function () {
      api.rerender('4c83afbf', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "ScriptsV2/Core/Modules/SprintPlanning/Components/Comment.vue"
export default component.exports